import { RouteEntry } from "../../shared/routes";
import { IdentityRoles } from "../../configure/security/IdentityRoles";
import { SubscriptionQuestionnairesHome } from "./SubscriptionQuestionnairesHome";

export const subscriptionQuestionnairesRoutes: Array<RouteEntry> = [
    { path: '/subscriptionQuestionnaires', exact: true, component: SubscriptionQuestionnairesHome, authorize: true, requireRole: IdentityRoles.SubscriptionAdministration },
];

